module.exports = __webpack_public_path__ + "1791188489487/fonts/WorkSans-Medium.d8f4a3a.woff2";